import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';

export const StyledVideoBox = styled(Box)`
  text-align: center;
`;

export const StyledVideo = styled(Box)`
  vertical-align: top;
  margin: 0 auto;
  width: 100%;
` as typeof Box;
